import React from 'react';
import PropTypes from 'prop-types';

import ClassComponent from '../utils/ClassComponent';

import Popup from './Popup';
import BrorTransition from '../Transition';

export default class IntroPopup extends React.Component {
  static propTypes = {
    showPopup: PropTypes.bool,
    wiggle: PropTypes.bool,
    children: PropTypes.node,
    content: PropTypes.any.isRequired,
    querySelector: PropTypes.string,
    arrowAlignment: PropTypes.string,
  };

  _component = React.createRef();

  state = {
    hasRendered: false,
    target: null,
  };

  componentDidMount() {
    this._setHasRendered();
  }

  _getChild() {
    const child = React.Children.only(this.props.children);

    const isStateless =
      typeof child.type !== 'string' &&
      !React.Component.isPrototypeOf(child.type);

    if (isStateless) {
      return <ClassComponent ref={this._component}>{child}</ClassComponent>;
    }

    return React.cloneElement(child, { ref: this._component });
  }

  _setHasRendered() {
    const target = document.querySelector(this.props.querySelector);

    this.setState({
      hasRendered: true,
      target: target || this._component.current,
    });
  }

  _waitForComponent(delay = 200, tries = 20) {
    const component = this._component.current;

    let count = 0;

    const interval = setInterval(() => {
      if (component.dataset.rendered === 'true' || count > tries) {
        clearInterval(interval);

        this._setHasRendered();
      }

      count++;
    }, delay);
  }

  render() {
    const { showPopup, wiggle } = this.props;
    const { hasRendered, target } = this.state;

    return (
      <React.Fragment>
        {this._getChild()}
        {hasRendered && (
          <BrorTransition in={showPopup}>
            <Popup wiggle={wiggle} target={target} {...this.props}>
              {this.props.content}
            </Popup>
          </BrorTransition>
        )}
      </React.Fragment>
    );
  }
}
